import { useState, useEffect } from "react";
import styled from "styled-components";
import { getRandomMessage } from "../utils/loadingMessages";
import RandomGame from "./games";

const LoadingMessage = styled.span`
    display: block;
    font-size: 16px;
    color: #C8C8C8;
    margin: 25px 0 12px;
    word-break: keep-all;
    line-height: 1.4;
    padding: 0 10px;

    @media (max-width: 520px) {
        font-size: 3.0769vw;
        margin: 4.8077vw 0 2.3077vw;
        padding: 0 1.9231vw;
    }
`;

const GameSection = styled.div`
    margin-top: 20px;

    @media (max-width: 520px) {
        margin-top: 3.8462vw;
    }
`;

export default function Loading({Constellation}){
    const [message, setMessage] = useState(getRandomMessage());

    useEffect(() => {
        setMessage(getRandomMessage());
    }, []);

    return(
        <div className="loadingPage">
            <div className="loadingPage_inner">
                <Constellation></Constellation>
                <div className="loadingContent">
                    <div className="circleBox">
                        <div className="circleBox_inner"></div>
                        <h4>
                            <img src={process.env.PUBLIC_URL + '/image/logo.png'} alt='별별운세' />
                        </h4>
                    </div>
                    <LoadingMessage>{message}</LoadingMessage>
                    <GameSection>
                        <RandomGame theme="default" />
                    </GameSection>
                </div>
            </div>
        </div>
    )
}
